import React from 'react';
import { Box } from 'rebass/styled-components';

import { layout } from '../../../../constants/constants';
import { Media } from '../../../contexts/media/MediaContext';
import { FeatureToggle, InsetHeadlineHeroContent } from '../../../models/app-data-model';
import Breadcrumbs from '../../bread-crumbs/breadcrumbs';
import './inset-headline-hero.scss';

export type HeroContentProps = {
  heroContent: InsetHeadlineHeroContent;
  featureToggles: FeatureToggle[];
};

const InsetHeadlineHero: React.FC<HeroContentProps> = ({ heroContent }: HeroContentProps) => {
  return (
    <>
      <div className="inset-headline-hero-parent">
        <div className="inset-headline-gradient-background"></div>
        <Media lessThan="desktop">
          <Box className="inset-headline-background-offset" width={layout.singleColWidth}>
            <div className="inset-headline-background"></div>
          </Box>
          <Box
            className="inset-headline-hero"
            data-testid={`inset-headline-hero${heroContent.padding_bottom ? '-additional-padding' : ''}`}
            pb={heroContent.padding_bottom ? 7 : 3}
            width={layout.singleColWidth}
          >
            <Box px={layout.pagePaddingX} className="inset-headline-hero-content">
              <h1 className="title">{heroContent.header}</h1>
            </Box>
          </Box>
        </Media>
        <Media greaterThanOrEqual="desktop">
          <Box className="inset-headline-background-offset" marginX={'auto'} paddingX={layout.pagePaddingX} width={layout.pageWidth}>
            <div className="inset-headline-background"></div>
          </Box>
          <Box
            className="inset-headline-hero"
            data-testid={`inset-headline-hero${heroContent.padding_bottom ? '-additional-padding' : ''}`}
            width={layout.singleColWidth}
            marginX={'auto'}
            pb={heroContent.padding_bottom ? 7 : 3}
          >
            <Box px={layout.pagePaddingX} className="inset-headline-hero-content">
              {heroContent?.breadcrumbs?.subsite && (
                <div className="breadcrumbs-container">
                  <Breadcrumbs breadcrumbsContent={heroContent.breadcrumbs}></Breadcrumbs>
                </div>
              )}
              <h1 className="title">{heroContent.header}</h1>
            </Box>
          </Box>
        </Media>
      </div>
    </>
  );
};

export default InsetHeadlineHero;
